import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetRelatedPassengersResponse } from '@/types/clientsApiTypes';
import { CLIENT_CREATE_RELATED_PASSENGERS_QUERY_KEY } from '../../const/const';

export const useGetRelatedPassengersQuery = () => {
  const [query] = useSearchQuery();
  const clientId = query.get(CLIENT_ID_QUERY_KEY);
  const { doFetch } = useFetch<void, GetRelatedPassengersResponse>();

  return useQuery({
    queryKey: [CLIENT_CREATE_RELATED_PASSENGERS_QUERY_KEY],
    queryFn: () => doFetch(`/api/client-details/${clientId}/related-passengers`),
    enabled: !!clientId,
  });
};
